// 옛날 버전 에러 타입
export default class ErrorType1 {
    /** 상태 코드 */
    statusCode = 0;
    data = {
        isSuccess: false,
        isPossible: false,
        /** 백엔드에서 주는 상태 코드 INVALID_STATUS */
        reason: '',
        /** 메시지 */
        message: '',
    };
    constructor(error = {}) {
        Object.assign(this, error);
    }
}
